import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/Logo";

function roleToPath(role) {
  if (role === "merchant") return "/merchant";
  if (role === "rider") return "/rider";
  if (role === "admin") return "/admin";
  return "/app";
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { refresh } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) { navigate("/login", { replace: true }); return; }
      const sessionId = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        window.history.replaceState({}, document.title, "/");
        await refresh();
        navigate(roleToPath(data.user.role), { replace: true });
      } catch (e) {
        console.error("Google sign-in failed:", e);
        navigate("/login", { replace: true, state: { error: e.response?.data?.detail } });
      }
    };
    run();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Logo size={44} />
        <div className="mt-5 text-cyan-300 heading-font uppercase tracking-widest text-xs animate-pulse">
          Linking your Google account…
        </div>
      </div>
    </div>
  );
}
